module.exports = __webpack_public_path__ + "img/sendi-banner.9787c4ef.jpg";